import React, { useState } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import DashboardCard24 from '../../partials/dashboard/DashboardCard24';

function Planning() {

    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1  overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className="w-full grid grid-cols-12 gap-4 justify-center">
                            <div className="col-span-12  w-full xs:pb-10 overflow-y-auto">
                                <DashboardCard24 />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default Planning;